export const BlueDot = require('./icons/bluedot.png')
export const Walkspot = require('./icons/walkspot.png')
export const Preview = require('./models/2021/preview.jpg')
export const AudioOnDark = require('./icons/audio-on-dark.gif')
export const AudioOn = require('./icons/audio-on.gif')
